import { observer } from "mobx-react";
import React from "react";
import "./Popover.css";
import Swiper from "react-id-swiper";

type Props = {
	headline?: string;
	description?: string;
	position?: string;
	incompatibleMessage?: string;
	thumbnail?: string;
	galleryImages?: [];
	onClose: () => void;
};

type State = {
	isOpen: boolean;
};

@observer
class Popover extends React.Component<Props, State> {
	wrapperRef: any;
	constructor(props: Props) {
		super(props);
		// set initial state in constructor directly
		this.state = {
			isOpen: false,
		};
		this.wrapperRef = React.createRef();
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleClickOutside(event: any) {
		if (this.wrapperRef && this.wrapperRef.current.contains(event.target)) {
			this.props.onClose();
		}
	}

	render() {
		const galleryImages = this.props.galleryImages || [];
		const params = {
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		};

		return (
			<>
				<div className="popover-wrapper">
					<div className="popover-box">
						<div className="popover-head">
							<div className="close" aria-label="Close" onClick={(e) => this.props.onClose()}></div>
						</div>
						<div className="popover-body">
							{galleryImages.length > 0 &&
								galleryImages.length <= 1 &&
								galleryImages.map((index) => {
									return <img key={`${index}-single-image`} className="modal-image" src={this.props.thumbnail} alt="" />;
								})}
							{galleryImages.length > 1 && (
								<Swiper {...params}>
									{galleryImages.map((gImage, index) => {
										return (
											<div key={`${index}-gallery-image`} className="swiper-slide">
												<img className="modal-image" src={gImage} alt="" />
											</div>
										);
									})}
								</Swiper>
							)}
							<h2 className="modal-headline text-left mb-1">{this.props.headline}</h2>
							<p className="text-left mb-0">{this.props.description}</p>
							{this.props.incompatibleMessage && <div className="incompatible-text">{this.props.incompatibleMessage}</div>}
						</div>
					</div>
					<div ref={this.wrapperRef} onClick={this.handleClickOutside} className="popover-mobile-background"></div>
				</div>
			</>
		);
	}
}

export default Popover;
